import { LeagueEnum, RoomType } from '../types/room'

export type DemoFootballSetting = {
  oneZero: string
  twoZero: string
  twoOne: string
  zeroZero: string
  oneOne: string
  twoTwo: string
  threeZero: string
  threeOne: string
  threeTwo: string
  threeThree: string
  fourZero: string
  fourOne: string
  fourTwo: string
  fourThree: string
  fourFour: string
  fiveAndMore: string
  fiveFiveMore: string
  correctResultPoints: string
  correctDrawPoints: string
  championAtStart: string
  championSecondChance: string
  enableFutureChampionStart: boolean
  enableFutureChampionSecondChance: boolean
  enableTopScorer: boolean
  topScorerPoints: string
  winnerAdditionalTime: string
  winnerPenalties: string
}

export type DemoRoomConfig = {
  name: string
  type: RoomType
  role?: string
  leagues: LeagueEnum[]
  setting: DemoFootballSetting
}

export const DEMO_SESSION_STORAGE_KEY = 'brc-football-demo-room'

export const DEFAULT_DEMO_ROOM_CONFIG: DemoRoomConfig = {
  name: 'World Cup Office Pool',
  type: RoomType.Individual,
  leagues: [LeagueEnum.WorldCup2026],
  setting: {
    oneZero: '1',
    twoZero: '1',
    twoOne: '1',
    zeroZero: '2',
    oneOne: '2',
    twoTwo: '2',
    threeZero: '2',
    threeOne: '2',
    threeTwo: '2',
    threeThree: '3',
    fourZero: '3',
    fourOne: '3',
    fourTwo: '3',
    fourThree: '3',
    fourFour: '4',
    fiveAndMore: '5',
    fiveFiveMore: '5',
    correctResultPoints: '1',
    correctDrawPoints: '1',
    championAtStart: '20',
    championSecondChance: '10',
    enableFutureChampionStart: true,
    enableFutureChampionSecondChance: false,
    enableTopScorer: true,
    topScorerPoints: '20',
    winnerAdditionalTime: '2',
    winnerPenalties: '3',
  },
}

export function loadDemoRoomSession(): DemoRoomConfig | null {
  try {
    const raw = sessionStorage.getItem(DEMO_SESSION_STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as DemoRoomConfig
  } catch {
    return null
  }
}

export function saveDemoRoomSession(config: DemoRoomConfig): void {
  sessionStorage.setItem(DEMO_SESSION_STORAGE_KEY, JSON.stringify(config))
}

export function clearDemoRoomSession(): void {
  sessionStorage.removeItem(DEMO_SESSION_STORAGE_KEY)
}
